import React from 'react';
import QivratechLogo from './QivratechLogo';

// Legacy wrapper for backward compatibility
const Logo = ({ 
  className = "", 
  size = "default", 
  animated = false, 
  variant = "full",
  theme = "dark"
}) => {
  return (
    <QivratechLogo 
      className={className}
      size={size}
      variant={variant}
      animated={animated}
      theme={theme}
    />
  );
};

export default Logo;